(async () => {
  const el = document.getElementById('service-list-town-content')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/services/[...slug].vue'),
    },
  ]

  await clientRender({ components })
})()
